module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Cardboard-vr-ec6c3226e31d919e85f72d352759a3e1.svg";